<template>
    <a-slider class="gallery" pagination-alignment="center" :options="SLIDER_OPTIONS">
        <a-slide v-for="file in data.files" :key="file">
            <a-media
                type="screenshot"
                :link="file"
                :alt="title || ''"
                fit="cover"
            />
        </a-slide>
    </a-slider>
</template>

<script setup lang="ts">
import AMedia from '@core/components/media/media.vue';
import ASlide from '@core/components/slider/slide.vue';
import ASlider from '@core/components/slider/slider.vue';
import type { BodyVariant, ImageGalleryData } from '@model/editor-js/blocks';

defineOptions({
    name: 'BlockImageGallery',
});

defineProps<{
    id?: string;
    data: ImageGalleryData;
    variant: BodyVariant;
    title?: string;
}>();

const SLIDER_OPTIONS = {
    spaceBetween: 0,
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    watchOverflow: false,
    showNavigation: true,
    useAutoplay: true,
    slideChangeSeconds: 4,
    useLoop: true,
    useBarsPagination: true,
};
</script>

<style lang="pcss" scoped>
.body-renderer .gallery {
    max-width: 764px;
    margin-inline: auto;
    margin-block: 24px;

    :deep(.screenshot-image) {
        box-shadow: none;
    }
}
</style>
